import { createFileRoute } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import InfoPage from '../../pages/UsefulInfo';
import { getUsefulInfo } from '../../server/getUsefulInfo';
import { destinationMiddleware } from '../../server/middleware/destinationMiddleware';

const loadDestination = createServerFn()
    .middleware([destinationMiddleware])
    .handler(async ({ context }) => {
        return context.destination;
    });

export const Route = createFileRoute('/useful-info/$slug')({
    loader: async ({ context }) => {
        const destination = await loadDestination();
        const usefulInfoData = destination?._id
            ? await getUsefulInfo({
                data: {
                    destinationId: destination._id,
                    page: 1,
                },
            }).catch(() => ({}))
            : {};
        return { destination, usefulInfoData };
    },
    // Server-rendered — see routes/index.jsx for why this replaces Helmet.
    head: ({ loaderData, params }) => {
        const destination = loaderData?.destination;
        const title = `${destination?.name} | Useful Information`;
        const description = `Find up-to-date and useful information about the ${destination?.name}!`;
        const image = destination?.images?.info?.[0]?.url;
        const siteUrl = (destination?.url || '').replace(/\/$/, '');

        return {
            meta: [
                { title },
                { name: 'description', content: description },
                { property: 'og:title', content: title },
                { property: 'og:description', content: description },
                { property: 'og:type', content: 'website' },
                ...(siteUrl
                    ? [{ property: 'og:url', content: `${siteUrl}/useful-info/${params.slug}` }]
                    : []),
                ...(image ? [{ property: 'og:image', content: image }] : []),
            ],
        };
    },
    component: InfoPage,
});